var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import throttle from 'lodash.throttle';

var ns = '$$vResizeContext';
var defaultOptions = {
  resizableClass: 'vrz-resizable',
  draggedClass: 'vrz-dragged',
  resizingClass: 'vrz-resizing',
  directions: ['bottom', 'right'],
  zoneSize: 4
};

var createObservable = function createObservable(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? {} : _ref$data,
      _ref$watch = _ref.watch,
      watch = _ref$watch === undefined ? {} : _ref$watch;

  var o = {
    $data: _extends({}, data)
  };

  Object.keys(data).forEach(function (key) {
    Object.defineProperty(o, key, {
      get: function get() {
        return o.$data[key];
      },
      set: function set(value) {
        if (value !== o.$data[key]) {
          watch[key] && watch[key](value, o.$data[key]);
        }

        o.$data[key] = value;
      }
    });
  });

  return o;
};

var Resize = function () {
  function Resize(_ref2) {
    var options = _ref2.options,
        target = _ref2.target;

    _classCallCheck(this, Resize);

    this.options = options;
    this.target = target;

    this.state = createObservable({
      data: {
        isResizable: false,
        isDragged: false,
        isResizing: false,
        direction: null
      },
      watch: {
        isResizable: this.handleResizableChange.bind(this),
        isDragged: this.handleDraggedChange.bind(this),
        isResizing: this.handleResizingChange.bind(this),
        direction: this.handleDirectionChange.bind(this)
      }
    });

    this.mousedown = this.mousedown.bind(this);
    this.mousemove = throttle(this.mousemove, 1000 / 60).bind(this);
    this.mouseup = this.mouseup.bind(this);
    this.mouseleave = this.mouseleave.bind(this);
  }

  _createClass(Resize, [{
    key: 'init',
    value: function init() {
      document.body.addEventListener('mousemove', this.mousemove);

      this.target[ns] = {
        mousedown: this.mousedown,
        mousemove: this.mousemove,
        mouseup: this.mouseup
      };
    }

    // events

  }, {
    key: 'mousedown',
    value: function mousedown() {
      if (this.state.isResizable) {
        this.state.isDragged = true;
      }
    }
  }, {
    key: 'mousemove',
    value: function mousemove(event) {
      var _this = this;

      var targetPos = this.target.getBoundingClientRect();
      var cursorPos = {
        x: event.clientX,
        y: event.clientY
      };

      if (this.state.isDragged) {
        // 开始缩放
        var frameMap = {
          top: function top() {
            this.target.style.height = targetPos.bottom - cursorPos.y + 'px';
          },
          bottom: function bottom() {
            this.target.style.height = cursorPos.y - targetPos.top + 'px';
          },
          left: function left() {
            this.target.style.width = targetPos.right - cursorPos.x + 'px';
          },
          right: function right() {
            this.target.style.width = cursorPos.x - targetPos.left + 'px';
          }
        };

        this.state.isResizing = true;

        return window.requestAnimationFrame(function () {
          if (!_this.state.direction) return;

          var drs = _this.state.direction.split('-');

          drs.forEach(function (item) {
            frameMap[item].call(_this);
          });

          _this.options.onResize && _this.options.onResize({
            direction: _this.state.direction,
            target: _this.target,
            event: event
          });
        });
      }

      this.checkHit(cursorPos, targetPos);
    }
  }, {
    key: 'mouseup',
    value: function mouseup() {
      this.state.isDragged = false;
      this.state.isResizing = false;
    }
  }, {
    key: 'mouseleave',
    value: function mouseleave() {
      this.state.isResizable = false;
      this.state.isDragged = false;
      this.state.isResizing = false;
    }
  }, {
    key: 'checkHit',
    value: function checkHit(cursorPos, targetPos) {
      var isInside = cursorPos.y >= targetPos.top && cursorPos.y <= targetPos.bottom && cursorPos.x >= targetPos.left && cursorPos.x <= targetPos.right;

      if (!isInside) {
        this.state.direction = null;
        this.state.isResizable = false;

        return;
      }

      var checkMap = {
        top: cursorPos.y - targetPos.top <= this.options.zoneSize,
        bottom: targetPos.bottom - cursorPos.y <= this.options.zoneSize,
        left: cursorPos.x - targetPos.left <= this.options.zoneSize,
        right: targetPos.right - cursorPos.x <= this.options.zoneSize
      };

      var res = this.options.directions.sort().filter(function (item) {
        return checkMap[item];
      });

      if (res.length) {
        this.state.direction = res.join('-');
        this.state.isResizable = true;
      } else {
        this.state.direction = null;
        this.state.isResizable = false;
      }
    }

    // watchers

  }, {
    key: 'handleResizableChange',
    value: function handleResizableChange(value) {
      if (value) {
        document.body.addEventListener('mouseup', this.mouseup);
        document.body.addEventListener('mousedown', this.mousedown);
        this.target.classList.add(this.options.resizableClass);
      } else {
        document.body.removeEventListener('mousedown', this.mousedown);
        document.body.removeEventListener('mouseup', this.mouseup);
        this.target.classList.remove(this.options.resizableClass);
      }
    }
  }, {
    key: 'handleDirectionChange',
    value: function handleDirectionChange(value) {
      var cursorMap = {
        top: 'ns-resize',
        bottom: 'ns-resize',
        left: 'ew-resize',
        right: 'ew-resize',
        'left-top': 'nwse-resize',
        'bottom-right': 'nwse-resize',
        'right-top': 'nesw-resize',
        'bottom-left': 'nesw-resize'
      };

      document.body.style.cursor = value ? cursorMap[value] : null;
    }
  }, {
    key: 'handleDraggedChange',
    value: function handleDraggedChange(value) {
      if (value) {
        document.body.addEventListener('mouseleave', this.mouseleave);
        document.body.style['user-select'] = 'none';
        this.target.classList.add(this.options.draggedClass);
      } else {
        document.body.removeEventListener('mouseleave', this.mouseleave);
        document.body.style['user-select'] = '';
        this.target.classList.remove(this.options.draggedClass);
      }
    }
  }, {
    key: 'handleResizingChange',
    value: function handleResizingChange(value) {
      if (value) {
        this.target.classList.add(this.options.resizingClass);
        // document.body.classList.add(this.options.resizingClass)
      } else {
        this.target.classList.remove(this.options.resizingClass);
        // document.body.classList.remove(this.options.resizingClass)
      }
    }
  }]);

  return Resize;
}();

export default {
  name: 'resize',
  inserted: function inserted(el, binding) {
    var rz = new Resize({
      target: el,
      options: _extends({}, defaultOptions, binding.value)
    });

    rz.init();
  },
  unbind: function unbind(el) {
    document.addEventListener('mousedown', el[ns].mousedown);
    document.addEventListener('mousemove', el[ns].mousemove);
    document.addEventListener('mouseup', el[ns].mouseup);
  }
};
